<template>
  <div>
    <div class="list-questions" :class="quiz.mode != 'play' ? 'no-play' : ''">
      <div class="wrap-question" v-for="(question,index) in quiz.questions" v-bind:key="index">
        <OnlyContent v-if="question.settings.optionDisplayStyle == 1 && !question.settings.questionTypeAnswer" :question="question" :index="index" :showResult="quiz.settings.script.displayTheCaptionForTheCorrectAnswer" />
        <OnlyImage v-if="question.settings.optionDisplayStyle == 2  && !question.settings.questionTypeAnswer" :question="question" :index="index" :showResult="quiz.settings.script.displayTheCaptionForTheCorrectAnswer"  />
        <ContentAndImage v-if="question.settings.optionDisplayStyle == 3  && !question.settings.questionTypeAnswer" :question="question" :index="index" :showResult="quiz.settings.script.displayTheCaptionForTheCorrectAnswer"  />
      </div>
    </div>
    <Result v-if="checkFinish" :quiz="quiz" :total_poin="total_poin" />
  </div>
</template>

<script>
import OnlyContent from './OnlyContent'
import OnlyImage from './OnlyImage'
import ContentAndImage from './ContentAndImage'
import Result from './Result'


export default {  
  name: "Main",
  components: {
    OnlyContent,
    OnlyImage,
    ContentAndImage,
    Result
  },
  computed: {
    quiz: function(){
      console.log('quizzz: ', this.$store.getters.quiz);
      return this.$store.getters.quiz
    },
    checkFinish: function(){
      const finish = this.$store.getters.numQuestionFinish
      if (finish == this.$store.getters.quiz.questions.length){
        return true
      }
      return 
    },
    total_poin: function() {
      let total = 0
      const get_answers = this.$store.getters.getAnswer
      get_answers.filter((x) => total += x.data.value)
      return total
    },
  }
};
</script>

<style lang="scss">
  @import '~@/styles/main.scss';
</style>